import { defineStore } from 'pinia';

// 默认显示的 PDF 列
const defaultPdfColumns = [
  'name',
  'generationTime',
  'size',
  'store',
  'workOrder',
  'actions'
];

export const useFileSettingsStore = defineStore('fileSettings', {
  state: () => ({
    pdfVisibleColumns: JSON.parse(localStorage.getItem('pdfVisibleColumns') || JSON.stringify(defaultPdfColumns)),
  }),
  actions: {
    setPdfVisibleColumns(columns) {
      this.pdfVisibleColumns = columns;
      localStorage.setItem('pdfVisibleColumns', JSON.stringify(columns));
    },
  },
});